import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminTimeComponent } from './admin-time.component';
const routes: Routes = [
  {
  path: '',
  component: AdminTimeComponent,
}]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminTimeRoutingModule { }
